<template>
<div>
<dl class="headings">
              <div class="row mx-4 mt-1">
                <div class="col-6">
                  <img src="../../../../static/logo.png" height="90" />
                </div>
                <div class="col-6 text-right">
                  <img src="" id="qr-code" height="90" />
                </div>
              </div>
              <dd class="text-center" style="font-size:22px; color: #32325d">
                <p>
                  <b>
                    <b>
                      <strong style="font-size:22px;"
                        >Government of Malawi</strong
                      >
                    </b>
                  </b>
                  <br />
                  <span>
                    <b>
                      <b>Department of Disaster Management Affairs (DoDMA)</b>
                    </b>
                  </span>
                </p>

                <p></p>
                <p>
                  <span
                    style="background:orange;width:100vh;padding-left:6px;padding-right:6px"
                  >
                    <b>
                      <b>Disaster Impact and Needs Reporting Form</b>
                    </b>
                  </span>
                </p>
              </dd>
            </dl>
            <div style="color: #32325d">
              <br />
              <p style="text-align:center;font-size:120% ;">
                <b>ACRONYMS</b>
              </p>
              <table
                style="margin:0 auto;padding:0px !important; border:none !important;width:92%;"
              >
                <tr
                  style="margin:0px !important;padding:0px !important; border:none;"
                >
                  <td
                    style="margin:0px !important;padding:0px !important; border:none;"
                  >
                    <table style="margin:0 auto;border:1px solid;padding:0px">
                      <tr>
                        <td style="width:20%">
                          <b>ADRMC </b>
                        </td>
                        <td>Area Disaster Risk Management Committee</td>
                      </tr>
                      <tr>
                        <td>
                          <b>DDRMC</b>
                        </td>
                        <td>District Disaster Risk Management Committee</td>
                      </tr>
                      <tr>
                        <td>
                          <b>GVH</b>
                        </td>
                        <td>Group Village Headman</td>
                      </tr>
                      <tr>
                        <td>
                          <b>HH</b>
                        </td>
                        <td>Household</td>
                      </tr>
                      <tr>
                        <td>
                          <b>NR</b>
                        </td>
                        <td>Not reported</td>
                      </tr>
                    </table>
                  </td>
                  <td
                    style="margin:4px !important;padding:4px !important; border:none;"
                  ></td>
                  <td
                    style="margin:0px !important;padding:0px !important; border:none;"
                  >
                    <table style="margin:0 auto;border:1px solid;padding:0px">
                      <tr>
                        <td>
                          <b>N/A</b>
                        </td>
                        <td>Not Applicable</td>
                      </tr>

                      <tr>
                        <td>
                          <b>TA</b>
                        </td>
                        <td>Tradition Authority</td>
                      </tr>
                      <tr>
                        <td>
                          <b>T</b>
                        </td>
                        <td>Total</td>
                      </tr>
                      <tr>
                        <td>
                          <b>VDRMC</b>
                        </td>
                        <td>Village Disaster  Risk Management Committee</td>
                      </tr>
                      <tr>
                        <td>
                          <b>VH</b>
                        </td>
                        <td>Village Headman</td>
                      </tr>
                    </table>
                  </td>
                </tr>
              </table>
              <br />
            </div>
</div>
</template>

<script>


export default {
  name: "Detailed",

  data() {
    return {};
  }
};
</script>
<style lang="stylus" scoped>
.modal-body .tags-input__wrapper{
   display: flex;
   flex-direction: row ;
   flex-wrap:  wrap;
}
.el-tag.el-tag--primary{
  position: relative !important;
  display: inline;
}
.image-previewer, .row {
  display: flex;
  flex-wrap: wrap;
  padding: 10px;
  justify-items: baseline;
}

.image-previewer .img, .row .img {
  height: 300px;
  border-radius: 10px;
  cursor: pointer;
}
.image-previewer  .image--wrapper {
  position: relative;
   margin: 10px;
}
.row  .image--wrapper {
  position: relative;
  margin: 10px;
  
}
.image-previewer .row .image--wrapper {
  margin: 10px;
}
.image--wrapper  .img--overlay {
  position: absolute;
  top: 0; 
  bottom: 0; 
  right: 0; 
  left: 0; 
  z-index: 10;
  background: rgba(0, 0, 0, .3);
  border-radius: 10px;
}
.image--wrapper .img--overlay .btn {
  background: rgb(238, 5, 5);
  width: 100%;
  position: absolute;
  bottom: 0;
}
.progress, .progress-bar {
  height: 30px;
  font-weight: bold;
}
.inner{
  overflow: hidden;
}
.inner img{
  transition: all 1.5s ease;
}
.inner:hover img{
  transform: scale(2);
   display: flex;
  flex-wrap: wrap;
}
table {
  border-collapse: collapse;
  width: 100%;
  margin: 0 auto;
}

table, th, td {
  border: 1px solid black;
  margin-top: 1%;
}

td {
  padding: 1%;
}

.rotated {
  writing-mode: tb-rl;
  transform: rotate(-180deg);
  color: teal;
}

.noborder {
  border: none;
}

.vertical {
  writing-mode: vertical-rl;
}

.qcont:first-letter {
  text-transform: capitalize;
}

.right-align {
  text-align: right;
}

@media print {
  .section-not-to-print {
    visibility: hidden;
  }
  #section-to-print {
    visibility: visible;
  }
}
</style>
